module.exports = __webpack_public_path__ + "static/media/Group_3651.9b3cdcfc.png";